export const RAILS_ROUTES = {
  ABOUT: '/about',
  ACTUATORS: '/actuators',
  ADMIN: '/admin',
  ADMIN_CHECKOUT: '/admin/checkout',
  APPLICATIONS: '/applications',
  BLOGS: '/blogs',
  CAREERS: '/careers',
  CHECKOUT_CART: '/checkout/cart',
  CNC_MACHINE_TENDING: '/cnc-machine-tending',
  CONTACT: '/contact',
  CONTACT_NEW: '/contact/new',
  CONVEYORS: '/conveyors',
  CUSTOMER_STORIES: '/customer-stories',
  DESIGNS_OVERVIEW: '/designs/overview',
  INDUSTRIAL_CARTS: '/industrial-carts',
  INDUSTRIAL_PALLETIZER: '/industrial-palletizer',
  MACHINE_TENDING: '/machine-tending',
  DASHBOARD: '/dashboard',
  DASHBOARD_CATALOG: '/dashboard/catalog',
  DASHBOARD_DESIGNS: '/dashboard/designs',
  DASHBOARD_MACHINE_ANALYTICS: '/dashboard/machine_analytics',
  DASHBOARD_NEW_DESIGN: '/dashboard/new-design',
  DASHBOARD_ORDERS: '/dashboard/orders',
  DASHBOARD_PROJECTS: '/dashboard/projects',
  DASHBOARD_SETTINGS_USER: '/dashboard/settings/user',
  DESIGN_TEMPLATES_ASSEMBLY: '/designs/official?category=AS#f-ec_category=AS',
  DESIGN_TEMPLATES_EOL_PACKAGING: '/designs/official?category=PZ#f-ec_category=PZ',
  DESIGN_TEMPLATES_MANUFACTURING: '/designs/official?category=MF#f-ec_category=MF',
  DESIGN_TEMPLATES_MATERIAL_HANDLING: '/designs/official?category=MH#f-ec_category=MH',
  DESIGNS_OFFICIAL: '/designs/official',
  EVENTS: '/events',
  EXPERIENCE_CENTER: '/experience-center',
  HARDWARE: '/hardware',
  HOME: '/?home',
  INDUSTRIES_AUTOMOTIVE: '/industries/automotive',
  MACHINE_ANALYTICS: '/machine-analytics',
  MACHINE_BUILDER: '/machine-builder',
  MACHINE_LOGIC: '/machine-logic',
  MACHINE_SCOPE: '/machine-scope',
  MACHINEMOTION_AI: '/machinemotion-ai',
  MANUFACTURING_AUTOMATION_PLATFORM: '/manufacturing-automation-platform',
  MARKETPLACE_PROGRAM: '/marketplace-program',
  INDUSTRIES_AEROSPACE_DEFENSE: '/industries/aerospace-and-defense',
  INDUSTRIES_CONSUMER_GOODS: '/industries/consumer-goods-manufacturing',
  INDUSTRIES_EDUCATION_RESEARCH: '/industries/higher-education-and-research',
  PALLETIZING_ROBOT: '/palletizing-robot',
  PARTS_LIBRARY: '/parts-library',
  PARTS_LIBRARY_EXTRUSIONS: '/parts-library?category=SF#f-ec_category=SF',
  PARTS_LIBRARY_ACTUATORS_MOTORS: '/parts-library?category=MV#f-ec_category=MV',
  PARTS_LIBRARY_ROBOT_ARMS: '/parts-library#q=robot%20arm',
  PARTS_LIBRARY_CONTROLLERS: '/parts-library?category=CM#f-ec_category=CM',
  PARTS_LIBRARY_GRIPPERS: '/parts-library?category=RA#f-ec_category=RA',
  PARTS_LIBRARY_SAFETY: '/parts-library?category=SA#f-ec_category=SA',
  PARTS_LIBRARY_FANUC: '/parts-library#f-ec_brand=Fanuc',
  PARTS_LIBRARY_UNIVERSAL_ROBOTS: '/parts-library#f-ec_brand=Universal%20Robots',
  PARTS_LIBRARY_ONROBOT: '/parts-library#f-ec_brand=OnRobot',
  PARTS_LIBRARY_SCHUNK: '/parts-library#f-ec_brand=Schunk',
  PARTS_LIBRARY_KEYENCE: '/parts-library#f-ec_brand=Keyence',
  PARTS_LIBRARY_FRANKA_ROBOTICS: '/parts-library#f-ec_brand=Franka%20Robotics',
  PATH_FOLLOWING: '/path-following',
  PICK_AND_PLACE: '/pick-and-place',
  PRESS: '/press',
  ROBOTIC_SANDING: '/robotic-sanding',
  ROBOTIC_WELDING: '/robotic-welding',
  RESOURCES_E_LEARNING: '/resources/e-learning',
  RESOURCES_FAQS: '/resources/faqs',
  RESOURCES_VIDEO_TUTORIALS: '/resources/video-tutorials',
  SERVICES_REMOTE_SUPPORT: '/services/remote-support',
  SIGNUP_GENERIC: '/signup',
  SUBSCRIPTIONS: '/subscriptions',
  TOOLS: '/tools',
  USERS_SIGN_IN: '/users/sign_in',
  VENTION_AUTOMATION_PARTNER: '/vention-automation-partner',
  WEBINARS: '/webinars',
  SEVENTH_AXIS: '/7th-axis',
  WORKSTATIONS: '/workstations',
};

export const MARKETING_ROUTES = {
  COBOT_PALLETIZER: '/cobot-palletizer',
  SERVICES: '/services',
  DEMO_DAY: '/demo-day',
  END_OF_LINE_SOLUTIONS: '/end-of-line-solutions',
  PHYSICAL_AI_PIPELINE: '/physical-ai-pipeline',
  RAPID_OPERATOR_AI: '/rapid-operator-ai',
  ROBOT_ARM: '/robot-arm',
  SERVICES_DEPLOYMENT_SERVICES: '/services/deployment-services',
  SERVICES_DESIGN_SERVICES: '/services/design-services',
  SERVICES_REMOTE_SUPPORT: '/services/post-sale-support',
  SERVICES_TRAINING_SESSIONS: '/services/training-sessions',
};

export const EXTERNAL_ROUTES = {
  BOOK_MEETING: 'https://vention.io/free-video-call',
  DOC360_TECH_DOC_KNOWLEDGE_BASE: 'https://docs.vention.io',
  DOCS_API: 'https://docs.vention.io/docs/application-programming-interface-python',
  DOCS_RELEASE_NOTES: 'https://docs.vention.io/release-notes',
  HOW_TO_GUIDES: 'https://docs.vention.io/docs/search?searchtext=how%20to&selectedTab=2',
};
